import styled from 'styled-components';

import { BREAKPOINTS } from 'common/styles/style-constants';

export const Container = styled.div`
  width: 100%;
  padding: 0 15px;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: ${props => props.height};

  @media (min-width: ${BREAKPOINTS.smallTabletMin}px) {
    padding-left: 30px;
    padding-right: 30px;
  }
`;

export const Copy = styled.div`
  @media (min-width: ${BREAKPOINTS.tabletMin}px) {
    display: flex;
  }
`;
